import { Component, OnInit, ViewChild, ChangeDetectorRef, ViewChildren, AfterContentChecked, Testability } from '@angular/core';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { MessageService } from 'primeng/api';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import {  SelectItem, LazyLoadEvent } from 'primeng/primeng';
import { FiltroCoDocumentoCobrar } from '../../dominio/FiltroCoDocumentoCobrar';
import { CoDocumentoServicio } from '../../service/codocumento.service';
import { MaMiscelaneosdetalleServicio } from 'src/app/erp/core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { PersonamastSelectorComponent } from 'src/app/erp/core/personamast/vista/selector/personamastselector.component';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { CoCobranza } from '../../../cocobranza/dominio/CoCobranza';
import { DatePipe } from '@angular/common';
import { TipocambiomastServicio } from 'src/app/erp/core/tipocambiomast/service/tipocambiomast.service';
import { CoDocumentocobranza } from '../../../codocumentocobranza/dominio/CoDocumentocobranza';
import { TipocambiomastPk } from 'src/app/erp/core/tipocambiomast/dominio/Tipocambiomast';
import { CoTipoPagoServicio } from '../../../cotipopago/service/cotipopago.service';
import { CoTipopago } from '../../../cotipopago/dominio/CoTipopago';
import { CoCobranzadetalle } from '../../../cocobranzadetalle/dominio/CoCobranzadetalle';
import { ParametrosmastPk } from 'src/app/erp/core/parametrosmast/dominio/Parametrosmast';
import { ParametrosmastServicio } from 'src/app/erp/core/parametrosmast/service/parametrosmast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CoCobranzaServicio } from '../../../cocobranza/service/cocobranza.service';
import { DtoCobranza } from '../../../cocobranza/dominio/DtoCobranza';
import { FiltroPersonamast } from '../../../../core/personamast/dominio/FiltroPersonamast';
import { PersonamastServicio } from '../../../../core/personamast/service/personamast.service';
import { Table } from 'primeng/table';

@Component({
    templateUrl: './codocumentocobrar-listado.component.html'
})

export class CoDocumentoCobrarlistadoComponent extends PrincipalBaseComponent implements OnInit {

    PG_DOCUMENTOS_LISTAR: number = 0;
    PG_REALIZAR_COBRANZA: number = 1;
    PG_REALIZAR_COBRANZA_PAGO: number = 2;
    PG_CLIENTE_SELECTOR: number = 3;

    PG_ACTUAL: number = 0;

    @ViewChild(PersonamastSelectorComponent,{static:false}) personamastSelectorComponent: PersonamastSelectorComponent;
    verCancelar: boolean = false;
    lstEstados: SelectItem[] = [];
    filtro: FiltroCoDocumentoCobrar = new FiltroCoDocumentoCobrar();
    seleccionados: any[] = [];
    cargando: boolean = true;
    numerodoc: string = '';
    dtoCobranza: DtoCobranza = new DtoCobranza();
    action: string;
    puedeEditar: Boolean = true;
    habilitarBtn: Boolean = true;
    modificar: Boolean = true;
    beanDetalle: CoCobranzadetalle[] = [];
    lstTipoPagoB: CoTipopago[] = [];
    lstTipoPago: SelectItem[] = [];
    lstBancos: SelectItem[] = [];
    lstMonedas: SelectItem[] = [];
    cobranza: CoCobranza = new CoCobranza();
    tipoCambio: number;
    tipoCambioCadena: string;

    iv_cobctabalo: string;
    iv_cobctabaex: string;

    iv_COBREDCBEX: string;
    iv_COBREDCBLO: string;

    acticonstDoc: Boolean = false;
    acticonstCli: Boolean = false;
    totalDolares: number;
    totalSoles: number;
    filtrofechas: Boolean = true;
    filtroCancelar: FiltroPersonamast = new FiltroPersonamast();
    lstClientes: any[];
    dtoPersonamast: DtoPersonamast = new DtoPersonamast();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private parametrosmastServicio: ParametrosmastServicio,
        private coTipoPagoServicio: CoTipoPagoServicio,
        private tipocambiomastServicio: TipocambiomastServicio,
        private datePipe: DatePipe,
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private coDocumentoServicio: CoDocumentoServicio,
        private cdref: ChangeDetectorRef,
        private personamastServicio: PersonamastServicio,
        private coCobranzaServicio: CoCobranzaServicio,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService
    ) { super(noAuthorizationInterceptor, messageService); }
    paginacion: any = new Object();
    @ViewChild(Table,{static:false}) dt: Table;

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    filterClienteSingle(event) {
        let query = event.query;
        this.personamastServicio.listarClientes(query).then(
            res => {
                this.lstClientes = res;
            }
        );
    }
    captureId(event: any) {
        this.dtoPersonamast.busqueda = event.busqueda;
        this.dtoPersonamast.persona = event.persona;
    }

    limpiarCliente() {
        this.dtoPersonamast = new DtoPersonamast()
    }

    ngOnInit() {
        this.bloquearPagina();
        super.ngOnInit();
        this.cargarEstados();
        this.filtro.desde = new Date();
        this.filtro.hasta = new Date();

        if (this.route.snapshot.params['accion'] === undefined && this.route.snapshot.params['bean'] === undefined) {

            this.action = 'COBRAR';
            const cliente = this.route.snapshot.params['cliente'];
            this.puedeEditar = true;
            this.habilitarBtn = true;
            this.modificar = true;
            if (cliente !== null) {
                this.verCancelar = true;
            }
            if (cliente) {
                const clienteBean = JSON.parse(cliente) as DtoPersonamast;
                this.dtoPersonamast.busqueda = clienteBean.busqueda;
                this.dtoPersonamast.persona = clienteBean.persona;
                this.filtro.estado = 'PR';
            }

        } else {
            this.action = this.route.snapshot.params['accion'];
            if (this.action === 'EDITAR' || this.action === 'VER') {
                this.dtoCobranza = JSON.parse(this.route.snapshot.params['bean']);
            }

            if (this.action === 'EDITAR') {
                this.puedeEditar = true;
                this.habilitarBtn = false;
                this.modificar = false;
            } else if (this.action === 'VER') {
                this.puedeEditar = false;
                this.habilitarBtn = false;
                this.modificar = true;
            } else if (this.action === 'VERDESDEDASHBOAR') {
                this.cargando = false;
                const cliente = this.route.snapshot.params['bean'];
                this.puedeEditar = true;
                this.habilitarBtn = true;
                this.modificar = true;
                if (cliente !== null) {
                    this.verCancelar = true;
                }
                if (cliente) {
                    const clienteBean = JSON.parse(cliente) as DtoPersonamast;
                    this.filtro.idVendedor = clienteBean.vendedor;
                    this.filtro.conVencidos = clienteBean.conVencidos;
                    this.filtro.estado = 'PR';
                }
            } else if (this.action === 'VERCLIENTE') {
                const cliente = this.route.snapshot.params['cliente'];
                this.puedeEditar = true;
                this.habilitarBtn = true;
                this.filtrofechas = false;
                this.filtro.desde = null;
                this.filtro.hasta = null;
                this.modificar = true;
                if (cliente !== null) {
                    this.verCancelar = true;
                }
                if (cliente) {
                    let filtro = this.route.snapshot.params['filtro'];
                    if (filtro !== undefined) {
                        this.filtroCancelar = JSON.parse(this.route.snapshot.params['filtro']) as FiltroPersonamast;
                    }
                    const clienteBean = JSON.parse(cliente) as DtoPersonamast;
                    this.dtoPersonamast.busqueda = clienteBean.busqueda;
                    this.dtoPersonamast.persona = clienteBean.persona;

                }
            }

            if (this.action === 'EDITAR' || this.action === 'VER') {
                this.PG_ACTUAL = this.PG_REALIZAR_COBRANZA;

                this.coCobranzaServicio.obtenerPorIdCompleto(this.dtoCobranza.unidadReplicacion, this.dtoCobranza.numeroCobranza).then(
                    resp => {
                        this.cobranza = resp;
                        this.cobranza.auxNombreCliente = resp.documentos[0].codocumento.clientenombre.trim();
                        for (let i = 0; i < this.cobranza.documentos.length; i++) {
                            const bean = this.cobranza.documentos[i];
                            bean.codocumento.monedadocumento = bean.codocumento.monedadocumento === 'EX' ? 'Dolares' : 'Soles';
                        }
                        this.beanDetalle = resp.detalle;
                    }
                );
            }
        }


        this.ngOnInitRealizarCobranza();
        this.ngOnInitRealizarCobranzaDetalle();
        if (this.action === 'COBRAR') {
            this.cargarPaginacion({ first: 0, rows: 20 });
        }

    }

    toggleVisibility(e) {
        if (e) {
            this.filtro.desde = new Date();
            this.filtro.hasta = new Date();
        } else {
            this.filtro.desde = null;
            this.filtro.hasta = null;
        }
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    cargarEstados() {
        this.bloquearPagina();
        this.lstEstados.push({ label: 'TODO ESTADO', value: null });
        this.maMiscelaneosdetalleServicio.listarPorCabecera('CO', '999999', 'DOCUEST').then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstados.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                );
                this.filtro.estado = 'PR';
                this.filtro.conVencidos = true;
                this.cargando = false;
                this.desbloquearPagina();
            }
        );
    }

    cancelarAccionSelector() {
        this.cargando = true;
        this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
    }

    cargarPaginacion(event: LazyLoadEvent) {
        if (this.cargando) {
            this.cargando = false;
            this.desbloquearPagina();
            return;
        }

        this.bloquearPagina();

        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;
        this.filtro.cliente = this.dtoPersonamast.persona;
        this.filtro.nombreCliente = this.dtoPersonamast.busqueda;
        this.totalSoles = 0;
        this.totalDolares = 0;
        this.coDocumentoServicio.listarDocumentosPorCobrarPaginacion(this.filtro)
            .then(res => {
                this.filtro.paginacion = res;
                if (this.filtro.paginacion.listaResultado.length > 0) {
                    this.filtro.paginacion.listaResultado.forEach(item => {
                        this.totalSoles = this.totalSoles + item.montoPendienteSoles;
                        this.totalDolares = this.totalDolares + item.montoPendienteDolares;
                    });
                }
                this.filtro.idVendedor = undefined;
                this.desbloquearPagina();
            });
    }

    buscar() {
        if (this.filtrofechas === false) {
            if (this.estaVacio(this.filtro.numero) && this.estaVacio(this.dtoPersonamast.persona)) {
                this.mostrarMensajeAdvertencia('Debe Seleccionar un cliente o introducir un número de documento');
                this.desbloquearPagina();
                return;
            }
        }


        if (this.filtrofechas === false) {
            this.filtro.desde = null;
            this.filtro.hasta = null;

            if (this.filtro.desde != null && this.filtro.hasta != null) {
                if (this.filtro.desde > this.filtro.hasta) {
                    this.mostrarMensajeAdvertencia('La fecha de Fin debe se mayor o igual que la fecha de Inicio');
                    this.desbloquearPagina();
                    return;
                }
            }

        }

        this.cargando = false;
        this.dt.reset();
    }

    mostrarSelectorCliente() {
        this.personamastSelectorComponent.iniciarComponente();
        this.PG_ACTUAL = this.PG_CLIENTE_SELECTOR;
    }

    verSeguimiento() {
        this.numerodoc = this.seleccionados[0].numeroDocumento;
        this.router.navigate(['royal/pedido_seguimiento', JSON.stringify(this.numerodoc)], { skipLocationChange: true });
    }

    cobrar() {
        const pk = new TipocambiomastPk();
        pk.fechacambio = new Date();
        this.tipocambiomastServicio.obtenerTipoCambio(pk).then(
            tipoCambio => {

                if (tipoCambio !== null) {
                    if (tipoCambio.factorcobranzaventa !== null) {
                        this.tipoCambio = tipoCambio.factorcobranzaventa;
                        this.tipoCambioCadena = tipoCambio.factorcobranzaventa.toFixed(3);
                    }

                }

                this.bloquearPagina();
                if (this.seleccionados.length === 0) {
                    this.desbloquearPagina();
                    this.mostrarMensajeAdvertencia('Seleccione como mínimo un documento');
                    return;
                }

                if (this.tipoCambio === null) {
                    this.desbloquearPagina();
                    this.mostrarMensajeAdvertencia('No se encontró tipo de cambio para el día ' + (this.datePipe.transform(new Date(), 'dd/MM/yyyy')));
                    return;
                }

                // VALIDAR QUE TODOS LOS DOCS SEAN DE UN MISMO CLIENTE
                const clienteGuia = this.seleccionados[0].clienteNumero;
                const monedaGuia = this.seleccionados[0].monedaDocumento;

                let diferentesClientes = false;
                let diferentesMonedas = false;

                this.seleccionados.forEach(
                    x => {
                        if (x.clienteNumero !== clienteGuia) {
                            diferentesClientes = true;
                        }
                        if (x.monedaDocumento !== monedaGuia) {
                            diferentesMonedas = true;
                        }
                    }
                );

                if (diferentesClientes) {
                    this.desbloquearPagina();
                    this.mostrarMensajeAdvertencia('Los Documentos deben de pertenecer a un mismo cliente');
                    return;
                }

                if (diferentesMonedas) {
                    this.desbloquearPagina();
                    this.mostrarMensajeAdvertencia('Los Documentos a cobrar deben tener la misma Moneda');
                    return;
                }


                // validar que del total estos sean los mas antiguos


                /*
                //no tiene consistencia, validar docs de la lista actual como hace spring, ya que si se filtra la validacion se pierde
                */


                // fin validacion de fecha de vencimiento

                this.nuevaCobranza();
            }
        );
    }

    obtenerTipoCambioHoy() {
        const pk = new TipocambiomastPk();
        pk.fechacambio = new Date();

        this.tipocambiomastServicio.obtenerTipoCambio(pk).then(
            tipoCambio => {

                if (tipoCambio !== null) {
                    if (tipoCambio.factorcobranzaventa !== null) {
                        this.tipoCambio = tipoCambio.factorcobranzaventa;
                        this.tipoCambioCadena = tipoCambio.factorcobranzaventa.toFixed(3);
                    }

                }
            }
        );
    }

    ngOnInitRealizarCobranza() {
        this.obtenerTipoCambioHoy();
        this.lstMonedas.push({ value: 'LO', label: 'Local' });
        this.lstMonedas.push({ value: 'EX', label: 'Dólares' });

        const pklo = new ParametrosmastPk();
        pklo.aplicacioncodigo = 'CO';
        pklo.companiacodigo = '999999';
        pklo.parametroclave = 'COBCTABALO';

        this.parametrosmastServicio.obtenerPorId(pklo).then(
            x => {
                if (x.texto !== null && x.texto !== undefined) {
                    this.iv_cobctabalo = x.texto.trim();
                }
            }
        );

        const pkex = new ParametrosmastPk();
        pkex.aplicacioncodigo = 'CO';
        pkex.companiacodigo = '999999';
        pkex.parametroclave = 'COBCTABAEX';

        this.parametrosmastServicio.obtenerPorId(pkex).then(
            x => {
                if (x.texto !== null && x.texto !== undefined) {
                    this.iv_cobctabaex = x.texto.trim();
                }
            }
        );


        const pkrelo = new ParametrosmastPk();
        pkrelo.aplicacioncodigo = 'CO';
        pkrelo.companiacodigo = '999999';
        pkrelo.parametroclave = 'COBREDCBLO';

        this.parametrosmastServicio.obtenerPorId(pkrelo).then(
            x => {
                if (x.texto !== null && x.texto !== undefined) {
                    this.iv_COBREDCBLO = x.texto.trim();
                }
            }
        );

        const pkreex = new ParametrosmastPk();
        pkreex.aplicacioncodigo = 'CO';
        pkreex.companiacodigo = '999999';
        pkreex.parametroclave = 'COBREDCBEX';

        this.parametrosmastServicio.obtenerPorId(pkrelo).then(
            x => {
                if (x.texto !== null && x.texto !== undefined) {
                    this.iv_COBREDCBEX = x.texto.trim();
                }
            }
        );
    }

    nuevaCobranza() {
        this.cobranza = new CoCobranza();

        this.cobranza.cobrador = -1;

        // a este nivel todos los docs seran del mismo cliente
        // entonces como habra al menos un doc, se coge el nombre y id del cliente

        this.cobranza.auxNombreCliente = this.seleccionados[0].clienteNombre;
        this.cobranza.cliente = this.seleccionados[0].clienteNumero;

        this.cobranza.monedacodigo = 'LO';
        this.cobranza.fechacobranza = new Date();

        // copiar la lista seleccionados a la lista del detalle
        const temp = [];
        const dataKeyNoIngresadoAlmacen = [];

        this.seleccionados.forEach(
            doc => {
                if (doc.tipoDocumento === 'PE') {
                    // alert('FALTA EVALUAR CON PEDIDOS');
                    temp.push(this.generarCoDocumentocobranzaBean(doc));
                } else {
                    if (doc.clasificacion === 'DP') {
                        if (doc.cantidadAlmacen > 0) {
                            dataKeyNoIngresadoAlmacen.push(doc.dataKey);
                            this.mostrarMensajeError('Existe Material que aún no ha ingresado al Almacén');
                        } else {
                            temp.push(this.generarCoDocumentocobranzaBean(doc));
                        }
                    } else {
                        temp.push(this.generarCoDocumentocobranzaBean(doc));
                    }
                }
            }
        );

        // aquellos que no pasaron el filtro de wf_sql_validate_dp, se quitan de la lista
        dataKeyNoIngresadoAlmacen.forEach(
            eliminar => {
                this.seleccionados = this.seleccionados.filter(x => x.dataKey !== eliminar);
            }
        );

        this.cobranza.documentos = temp;

        this.PG_ACTUAL = this.PG_REALIZAR_COBRANZA;
        this.desbloquearPagina();
    }

    generarCoDocumentocobranzaBean(doc): CoDocumentocobranza {
        const docBean = new CoDocumentocobranza();
        docBean.pk.companiasocio = doc.companiaSocio;
        docBean.pk.tipodocumento = doc.tipoDocumento;
        docBean.pk.numerodocumento = doc.numeroDocumento;
        docBean.codocumento.fechadocumento = doc.fechaDocumento;
        docBean.codocumento.fechavencimiento = doc.fechaVencimiento;
        docBean.codocumento.monedadocumento = doc.monedaDocumento;
        docBean.codocumento.montopercepcion = doc.montoPercepcion;
        docBean.syCampocalculado.monto02 = 0;
        docBean.syCampocalculado.monto03 = 0;

        docBean.comentario = doc.comentario;

        const MontoPendiente = doc.montoTotal - doc.montoPagado;

        docBean.syCampocalculado.monto01 = MontoPendiente;
        docBean.montopagado = MontoPendiente;


        if (docBean.codocumento.monedadocumento === 'LO') {
            docBean.monto09 = docBean.montopagado; // igual
            docBean.monto10 = parseFloat((docBean.montopagado / this.tipoCambio).toFixed(2)); // aca / cambio
        } else {
            docBean.monto09 = parseFloat((docBean.montopagado * this.tipoCambio).toFixed(2)); // aca * cambio
            docBean.monto10 = docBean.montopagado; // igual
        }
        return docBean;
    }

    insertarDocumento() {
        this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
    }
    setMontoCobradoDocumento(tx: CoDocumentocobranza) {
        this.bloquearPagina();
        if (tx.codocumento.monedadocumento === 'LO') {
            tx.monto09 = parseFloat((tx.montopagado).toFixed(2));
            tx.monto10 = parseFloat((tx.monto09 / this.tipoCambio).toFixed(2));
        } else {
            tx.monto10 = parseFloat((tx.montopagado).toFixed(2)); // igual
            tx.monto09 = parseFloat((tx.montopagado * this.tipoCambio).toFixed(2)); // aca * cambio
        }
        const lst = [...this.cobranza.documentos];
        const indi = lst.indexOf(tx);
        lst[indi] = tx;

        this.cobranza.documentos = lst;
        this.desbloquearPagina();
    }
    eliminarDocumento(tx: CoDocumentocobranza) {
        this.seleccionados = this.seleccionados.filter(x => x.dataKey !== (tx.pk.tipodocumento.trim() + tx.pk.numerodocumento.trim()));
        this.cobranza.documentos = this.cobranza.documentos.filter(x => (x.pk.tipodocumento.trim() + x.pk.numerodocumento.trim()) !== (tx.pk.tipodocumento.trim() + tx.pk.numerodocumento.trim()));

        if (this.cobranza.documentos.length === 0) {
            this.cancelarCobranza();
        }
    }

    get totalCobrado(): string {
        let total = 0;
        this.cobranza.documentos.forEach(
            doc => {
                if (doc.montopagado) {
                    total = total + doc.montopagado;
                }
            }
        );
        return total.toFixed(2);
    }

    cancelarCobranza() {
        if (this.action === 'COBRAR') {
            this.seleccionados = [];
            this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
        } else {
            this.router.navigate(['/royal/cobranza-listado']);
        }
    }

    formaPago() {
        this.nuevaFormaPago();
    }

    obtenerNuevoTipoCambio() {
        if (this.cobranza.fechacobranza !== null) {
            const pk = new TipocambiomastPk();
            pk.fechacambio = this.cobranza.fechacobranza;

            this.tipocambiomastServicio.obtenerTipoCambio(pk).then(
                tipoCambio => {
                    if (tipoCambio !== null) {
                        if (tipoCambio.factorcobranzaventa !== null) {
                            this.tipoCambio = tipoCambio.factorcobranzaventa;
                            this.tipoCambioCadena = tipoCambio.factorcobranzaventa.toFixed(3);
                        } else {
                            this.desbloquearPagina();
                            this.mostrarMensajeAdvertencia('No se encontró tipo de cambio para el día ' + (this.datePipe.transform(this.cobranza.fechacobranza, 'dd/MM/yyyy')));
                            this.cobranza.fechacobranza = new Date();
                            this.obtenerNuevoTipoCambio();
                        }

                    } else {
                        this.desbloquearPagina();
                        this.mostrarMensajeAdvertencia('No se encontró tipo de cambio para el día ' + (this.datePipe.transform(this.cobranza.fechacobranza, 'dd/MM/yyyy')));
                        this.cobranza.fechacobranza = new Date();
                        this.obtenerNuevoTipoCambio();
                    }
                }
            );
        }
    }


    ngOnInitRealizarCobranzaDetalle() {
        this.coTipoPagoServicio.listarActivos().then(
            lst => {
                this.lstTipoPagoB = lst;
                this.lstTipoPagoB.forEach(
                    x => {
                        this.lstTipoPago.push({ label: x.descripcionlocal, value: x.pk.tipopago.trim() });
                    }
                );
            }
        );
        this.lstBancos.push({ label: '-- Seleccione --', value: null });
        this.coDocumentoServicio.listarBancos().then(
            resp => resp.forEach(
                b => {
                    this.lstBancos.push({ label: b.descripcioncorta, value: b.banco.trim() });
                }
            )
        );

        if (this.action === 'COBRAR') {
            this.acticonstDoc = false;
            this.acticonstCli = false;
        } else {
            this.acticonstDoc = true;
            this.acticonstCli = true;
        }
    }

    nuevaFormaPago() {
        if (this.action === 'COBRAR') {
            this.PG_ACTUAL = this.PG_REALIZAR_COBRANZA_PAGO;
        } else {
            this.PG_ACTUAL = this.PG_REALIZAR_COBRANZA_PAGO;
            this.cobranza.detalle = this.beanDetalle;
        }
        this.desbloquearPagina();
    }

    get totalPagadoLO(): string {
        let total = 0;
        this.cobranza.detalle.forEach(
            doc => {
                if (doc.montolocal) {
                    total = total + doc.montolocal;
                }
            }
        );
        return total.toFixed(2);
    }

    get totalPagadoEX(): string {
        let total = 0;
        this.cobranza.detalle.forEach(
            doc => {
                if (doc.montodolares) {
                    total = total + doc.montodolares;
                }
            }
        );
        return total.toFixed(2);
    }


    insertarPago() {
        const lst = [...this.cobranza.detalle];
        lst.push(this.generaNuevaLineaPago());
        this.cobranza.detalle = lst;
    }

    redondeo() {
        const lst = [...this.cobranza.detalle];
        const detalle = this.generaNuevaLineaPago();
        detalle.tipopago = 'AR';
        if (detalle.monedapago === 'LO') {
            detalle.cuentabancaria = this.iv_COBREDCBLO;
        }
        if (detalle.monedapago === 'EX') {
            detalle.cuentabancaria = this.iv_COBREDCBEX;
        }
        lst.push(detalle);
        this.cobranza.detalle = lst;
    }

    habilitarCampos(event: any) {
        const tipoPagoB = this.lstTipoPagoB.find(x => x.pk.tipopago.trim() === event.value.trim());

        if (tipoPagoB.utilizardocumentoflag === 'S' && tipoPagoB.pk.tipopago !== 'AD') {
            this.acticonstDoc = true;
        } else {
            this.acticonstDoc = false;
        }

        if (tipoPagoB.utilizarbancoflag === 'S') {
            this.acticonstCli = true;
        } else {
            this.acticonstCli = false;
        }

    }

    generaNuevaLineaPago(): CoCobranzadetalle {
        const detalle = new CoCobranzadetalle();

        detalle.tipopago = 'EF';
        detalle.monedapago = this.cobranza.monedacodigo;
        detalle.estado = 'PR';
        detalle.pk.linea = this.generarLinea();
        detalle.tipocambiopago = this.tipoCambio;

        let porPagarLocal = 0;
        let porPagarDolar = 0;

        this.cobranza.documentos.forEach(
            x => {
                if (isNaN(x.monto09)) {
                    x.monto09 = 0;
                }
                if (isNaN(x.monto10)) {
                    x.monto10 = 0;
                }
                porPagarLocal = porPagarLocal + x.monto09;
                porPagarDolar = porPagarDolar + x.monto10;
            }
        );

        let pagadoLocal = 0;
        let pagadoDolar = 0;

        this.cobranza.detalle.forEach(
            y => {
                pagadoLocal = pagadoLocal + y.montolocal;
                pagadoDolar = pagadoDolar + y.montodolares;
            }
        );

        detalle.montolocal = parseFloat((porPagarLocal - pagadoLocal).toFixed(2));
        detalle.montodolares = parseFloat((porPagarDolar - pagadoDolar).toFixed(2));

        if (detalle.monedapago === 'LO') {
            detalle.cuentabancaria = this.iv_cobctabalo;
        } else {
            detalle.cuentabancaria = this.iv_cobctabaex;
        }
        return detalle;
    }

    eliminarPago(bean: CoCobranzadetalle) {
        this.cobranza.detalle = this.cobranza.detalle.filter(x => x.pk.linea !== bean.pk.linea);
    }

    generarLinea() {
        if (this.cobranza.detalle.length === 0) {
            return 1;
        }
        let max = this.cobranza.detalle[0].pk.linea;
        this.cobranza.detalle.forEach(
            x => {
                if (max < x.pk.linea) {
                    max = x.pk.linea;
                }
            }
        );

        return max + 1;
    }

    evaluarCambioDetalle(tx: CoCobranzadetalle) {
        this.bloquearPagina();
        if (tx.monedapago === 'LO') {
            tx.montodolares = parseFloat((tx.montolocal / this.tipoCambio).toFixed(2));
        }
        if (tx.monedapago === 'EX') {
            tx.montolocal = parseFloat((tx.montodolares * this.tipoCambio).toFixed(2));
        }
        const lst = [...this.cobranza.detalle];
        const indi = lst.indexOf(tx);
        lst[indi] = tx;

        this.cobranza.detalle = lst;
        this.desbloquearPagina();
    }

    cancelarFormaPago() {
        this.cobranza.detalle = [];
        this.PG_ACTUAL = this.PG_REALIZAR_COBRANZA;
    }

    guardar() {

        // llenar utilizarBancoFlag
        this.bloquearPagina();

        this.cobranza.detalle.forEach(detalle => {
            if (detalle.tipopago !== undefined || detalle.tipopago != null) {
                const tipoPagoB = this.lstTipoPagoB.find(x => x.pk.tipopago.trim() === detalle.tipopago.trim());

                detalle.utilizarBancoFlag = tipoPagoB.utilizarbancoflag;
                detalle.utilizarDocumentoFlag = tipoPagoB.utilizardocumentoflag;
                detalle.utilizarTarjetaCreditoFlag = tipoPagoB.utilizartarjetacreditoflag;
                detalle.conciliableflag = tipoPagoB.conciliableflag;
                detalle.retencionFlag = tipoPagoB.retencionflag;

                if (detalle.utilizarBancoFlag === null || detalle.utilizarBancoFlag === undefined) {
                    detalle.utilizarBancoFlag = 'N';
                } else {
                    detalle.utilizarBancoFlag = detalle.utilizarBancoFlag.trim();
                } if (detalle.utilizarDocumentoFlag === null || detalle.utilizarDocumentoFlag === undefined) {
                    detalle.utilizarDocumentoFlag = 'N';
                } else {
                    detalle.utilizarDocumentoFlag = detalle.utilizarDocumentoFlag.trim();
                }
                if (detalle.utilizarTarjetaCreditoFlag === null || detalle.utilizarTarjetaCreditoFlag === undefined) {
                    detalle.utilizarTarjetaCreditoFlag = 'N';
                } else {
                    detalle.utilizarTarjetaCreditoFlag = detalle.utilizarTarjetaCreditoFlag.trim();
                }
                if (detalle.conciliableflag === null || detalle.conciliableflag === undefined) {
                    detalle.conciliableflag = 'N';
                } else {
                    detalle.conciliableflag = detalle.conciliableflag.trim();
                }
                if (detalle.retencionFlag === null || detalle.retencionFlag === undefined) {
                    detalle.retencionFlag = 'N';
                } else {
                    detalle.retencionFlag = detalle.retencionFlag.trim();
                }
            }
        });

        if (this.action === 'COBRAR') {
            this.coDocumentoServicio.registrar(this.cobranza).then(
                mensajes => {
                    this.desbloquearPagina();
                    if (mensajes !== null) {
                        this.seleccionados = [];
                        this.router.navigate(['royal/cobranza-listado']);
                        this.messageService.addAll(this.getMensajesUsuario(mensajes));
                        // this.PG_ACTUAL = this.PG_DOCUMENTOS_LISTAR;
                        this.buscar();
                    }
                }
            );
        } else {
            this.coDocumentoServicio.actualizar(this.cobranza).then(
                mensajes => {
                    this.desbloquearPagina();
                    if (mensajes !== null) {
                        this.seleccionados = [];
                        this.router.navigate(['royal/cobranza-listado']);
                        this.messageService.addAll(this.getMensajesUsuario(mensajes));
                        this.buscar();
                    }
                }
            );
        }

    }

    cancelar() {
        if (!this.estaVacio(this.filtroCancelar)) {
            this.router.navigate(['/royal/cliente-listado', '_', JSON.stringify(this.filtroCancelar)], { skipLocationChange: true });
        } else {
            this.router.navigate(['royal/cliente-listado']);
        }

    }

}



